import SystemSettings from './SystemSettings';

export default SystemSettings;
